/** @file Affine from a region attachment's image pixels (y-down) to slot-bone space (y-up). */
import { affine } from '@pose2d/math/affine';
import type { Affine } from '@pose2d/math/types';

/** Rig region placement with defaults applied, its size w x h and the original image size. */
export interface RegionFrame {
  x: number;
  y: number;
  rotation: number;
  scaleX: number;
  scaleY: number;
  w: number;
  h: number;
  origW: number;
  origH: number;
}

/** toLocal = T * C: C centres the image and flips y (scaled by w/origW, h/origH); T places it (x, y, rotation, scale). */
export function regionPixelToLocal(f: RegionFrame): Affine {
  const kx = f.w / f.origW;
  const ky = f.h / f.origH;
  const centre = [kx, 0, 0, -ky, (-f.origW / 2) * kx, (f.origH / 2) * ky];
  const place = affine.fromLocal(new Float64Array(6), f.x, f.y, f.rotation, f.scaleX, f.scaleY, 0, 0);
  return affine.mul(new Float64Array(6), place, centre);
}
